import React from 'react';
import { ChevronRight } from 'lucide-react';

interface QuickActionFeaturedProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export const QuickActionFeatured: React.FC<QuickActionFeaturedProps> = ({
  title,
  description,
  icon,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3.5 rounded-[14px] border border-sossiety-red-border bg-gradient-to-r from-sossiety-red-gradient-from to-sossiety-red-gradient-to hover:border-opacity-160 hover:from-opacity-130 hover:to-opacity-120 transition-all duration-200 group"
      style={{
        padding: '14px 18px',
      }}
    >
      {/* Icon container */}
      <div
        className="flex flex-shrink-0 items-center justify-center rounded-[14px] bg-sossiety-red-surface"
        style={{
          width: '50px',
          height: '50px',
        }}
      >
        {icon}
      </div>

      {/* Text */}
      <div className="flex-1 min-w-0 text-left">
        <p className="text-white text-base font-bold leading-tight">
          {title}
        </p>
        <p className="text-white/50 text-sm mt-1 leading-snug line-clamp-2">
          {description}
        </p>
      </div>

      {/* Chevron */}
      <ChevronRight size={20} className="text-sossiety-red flex-shrink-0 group-hover:translate-x-0.5 transition-transform" />
    </button>
  );
};
